import React from "react"
import FormControl from "@material-ui/core/FormControl"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormLabel from "@material-ui/core/FormLabel"

import { FormField } from "../../styles/Form"
import Alert from "@material-ui/lab/Alert"
import { ArbeidModel, ArbeidAction, ArbeidProps } from "../../store/arbeid"
import { UIModel, UIStateProps } from "../../store/ui"
import { Divider } from "@material-ui/core"
import FylkeMultiNew from "@nvdb-rapport/shared/src/components/AreaSelect/FylkeMultiNew"
import KommuneSelectNew from "@nvdb-rapport/shared/src/components/AreaSelect/KommuneSelectNew"
import tw from "twin.macro"

interface AreaSelectArbeidMedVeglisterProps {
  arbeidState: ArbeidModel
  arbeidDispatch: React.Dispatch<ArbeidAction>
  uiState: UIModel
}

function AreaSelectArbeidMedVeglister({
  uiState,
  arbeidDispatch,
  arbeidState,
}: AreaSelectArbeidMedVeglisterProps): JSX.Element {
  return (
    <div style={tw`my-10 p-0`}>
      <Divider variant="fullWidth" />

      <SelectAreaType
        uiState={uiState}
        arbeidDispatch={arbeidDispatch}
        arbeidState={arbeidState}
      />

      <AreaSelectFields
        uiState={uiState}
        arbeidDispatch={arbeidDispatch}
        arbeidState={arbeidState}
      />

      <Divider variant="fullWidth" />
    </div>
  )
}

export default AreaSelectArbeidMedVeglister

function SelectAreaType({
  uiState,
  arbeidDispatch,
  arbeidState,
}: UIStateProps & ArbeidProps) {
  const language = uiState.language

  const selectedAreaType = arbeidState.selectedAreaType
  const errorAreaType = arbeidState.errorAreaType
  return (
    <FormField tw="w-full my-0 my-5">
      <FormControl
        required
        error={errorAreaType}
        component="fieldset"
        style={{ width: "100%", textAlign: "left" }}
      >
        <FormLabel component="legend">
          {language === "nb_NO" ? "Velg områdetype" : "Vel områdetype"}
        </FormLabel>
        <RadioGroup
          aria-label="areaType"
          style={{ fontSize: "1rem", textAlign: "left", width: "100%" }}
          name="areaType"
          value={selectedAreaType ? selectedAreaType : ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.value === "fylker" || e.target.value === "kommuner") {
              arbeidDispatch({
                type: "UpdateAreaType",
                payload: e.target.value,
              })
            } else {
              console.error("Noe gikk galt")
            }
          }}
        >
          <FormControlLabel
            value="fylker"
            control={<Radio color="primary" size="small" />}
            label="Fylker"
          />
          <FormControlLabel
            value="kommuner"
            control={<Radio color="primary" size="small" />}
            label="Kommuner"
          />
        </RadioGroup>
        {errorAreaType && true && (
          <Alert severity="error">Du må velge områdetype</Alert>
        )}
      </FormControl>
    </FormField>
  )
}

function AreaSelectFields({
  uiState,
  arbeidDispatch,
  arbeidState,
}: UIStateProps & ArbeidProps) {
  return (
    <div style={tw`w-full mb-5`}>
      <div style={tw`mb-8`}>
        <FylkeMultiNew
          omraader={uiState.omraader}
          selectedFylker={arbeidState.selectedFylker}
          updateSelectedFylker={value =>
            arbeidDispatch({ type: "SetSelectedFylker2", payload: value })
          }
        />
      </div>
      {arbeidState.selectedAreaType === "kommuner" && (
        <KommuneSelectNew
          language={uiState.language}
          selectedFylker={arbeidState.selectedFylker}
          selectedKommuner={arbeidState.selectedKommuner}
          omraader={uiState.omraader}
          setSelectedKommuner={kommuner =>
            arbeidDispatch({
              type: "SetSelectedKommuner2",
              payload: kommuner,
            })
          }
        />
      )}
    </div>
  )
}
